import {
  DashboardIcon,
  UsersIcon,
  SettingsIcon,
  LogoutIcon,
} from "../../../assets/svgIcons";

/**
 * All possible sidebar navigation items.
 * Visibility is filtered at runtime based on role access config.
 */
export const sidebarItems = [
  {
    id: "dashboard",
    label: "Dashboard",
    icon: DashboardIcon,
  },
  {
    id: "users",
    label: "Form Submissions",
    icon: UsersIcon,
  },
  {
    id: "settings",
    label: "Settings",
    icon: SettingsIcon,
  },
];

/**
 * Returns sidebar items filtered by the role's allowed tabs.
 * @param {string[]} allowedTabs - from ROLE_ACCESS[role].tabs
 */
export const getFilteredSidebarItems = (allowedTabs = []) => {
  // console.log("[sidebarData] Filtering sidebar items for allowed tabs:", allowedTabs);
  const filtered = sidebarItems.filter((item) => allowedTabs.includes(item.id));
  // console.log("[sidebarData] Visible sidebar items:", filtered.map((i) => i.id));
  return filtered;
};

export { LogoutIcon };
